import Card from '~/scripts/services/model/card';
import KformComponent from '../kform-component';
import Query from '~/scripts/services/model/query';

export default class KtableComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentKtable | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		/** extra widget actions */
		this.actions = settings?.actions ?? [];
		this.disabled = settings?.disabled ?? false;
		this.fastImport = settings?.fastImport;
		this.input = false;
		this.options = {
			actions:     {
				delete:         true,
				export:         true,
				fastImport:     false,
				filters:        false,
				insertCreate:   true,
				insertExisting: true,
				refresh:        true,
				update:         true,
				updateCell:     false,
				upload:         false,
			},
			display:     {
				status: true,
			},
			height:      5,
			mode:        'normal',
			packet_size: 50,
			table:       {
				persistentSort: false,
			},
			target: null,
			...settings?.options,
		};
		this.query = new Query(settings?.query);
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-N'),
		}
	}
}
